<template>
  <div>
    <div class="product-add">
      <el-steps :active="stepActive" finish-status="success">
        <el-step title="签约信息"/>
        <el-step title="资质信息"/>
        <el-step title="结算规则"/>
        <el-step title="签约审核"/>
        <el-step title="开通完成"/>
      </el-steps>
    </div>
    <div class="common-form" style="display: flex">申请编号<h2 style="margin-left: 20px">{{ form.applymentNo }}</h2>
    </div>
    <el-divider><span class="icon iconfont icon-lakalazhifu">&nbsp;拉卡拉支付</span></el-divider>
    <div class="common-form">主体资料</div>
    <!--签约信息-->
    <el-form v-if="stepActive===0" ref="baseForm" size="small" :model="form" :rules="stepForm_rules01"
             label-width="200px" :disabled="payInfo.op==='view' || payInfo.op==='replenish'">
      <el-form-item label="支付类型" prop="applymentTypes">
        <el-tooltip class="item" effect="dark" placement="top-start">
          <div slot="content">1、请勾选申请的支付类型（至少一项），以便为你开通需要的支付权限。
          </div>
          <el-checkbox-group v-model="form.applymentTypes">
            <el-checkbox-button key="WECHAT" label="WECHAT">微信</el-checkbox-button>
            <el-checkbox-button key="ALIPAY" label="ALIPAY">支付宝</el-checkbox-button>
          </el-checkbox-group>
        </el-tooltip>
      </el-form-item>
    </el-form>

    <!--签约信息-->
    <el-form v-if="stepActive===0" ref="baseInfo" size="small" :model="form.baseInfo" :rules="stepForm_rules0"
             label-width="200px" :disabled="payInfo.op==='view' || payInfo.op==='replenish'" style="padding-bottom: 20px">
      <el-form-item label="进件POS类型" prop="posType">
        <el-select v-model="form.baseInfo.posType" placeholder="请选择">
          <el-option label="专业化扫码" value="WECHAT_PAY"></el-option>
          <el-option label="B2B收银台" value="B2B_CASHIER_DESK"></el-option>
          <el-option label="B2B收款码" value="B2B_QR_CODE"></el-option>
          <el-option label="传统POS" value="GENERAL_POS"></el-option>
          <el-option label="智能POS" value="SUPER_POS"></el-option>
        </el-select>
      </el-form-item>

      <!--主体资料-->
      <div class="common-form">主体资料</div>
      <el-form-item label="主体类型" prop="subject_type">
        <el-radio-group v-model="form.baseInfo.subject_type" @input="subjectTypeChange">
          <el-radio border label="SUBJECT_TYPE_INDIVIDUAL">小微商户</el-radio>
          <el-radio border label="SUBJECT_TYPE_ENTERPRISE">营业执照商户</el-radio>
        </el-radio-group>
      </el-form-item>

      <!--经营资料-->
      <div class="common-form">经营资料</div>
      <el-form-item label="商户注册名称" prop="merRegName">
        <template slot="label">
            <span>商户注册名称
              <el-tooltip class="item" effect="dark" placement="right">
                <i class="el-icon-question" style="font-size: 16px; vertical-align: middle;"></i>
                <div slot="content">
                  <p>小微商户，商户注册名称必须如下格式</p>
                  <p>商户_张三</p>
                </div>
              </el-tooltip>
            </span>
        </template>
        <el-input type="text" v-model="form.baseInfo.merRegName" class="max-w460"></el-input>
        <!--        <div class="gray9">权重越大，等级越高</div>-->
      </el-form-item>
      <el-form-item label="商户经营名称" prop="merBizName">
        <el-input type="text" v-model="form.baseInfo.merBizName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户地区" prop="merRegDistCode">
        <el-cascader
          ref="areaCascader"
          placeholder="商户地区"
          v-model="form.baseInfo.merRegDistCode"
          :options="areaList"
          filterable
          class="max-w460 f-item"
          @change="handleBankAddressChange"></el-cascader>
      </el-form-item>
      <el-form-item label="商户详细地址" prop="merRegAddr">
        <el-input type="textarea" v-model="form.baseInfo.merRegAddr" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商户MCC编号" prop="mccCode">
        <el-input type="text" v-model="form.baseInfo.mccCode" class="max-w460" :disabled="true"></el-input>
      </el-form-item>
      <!--结算银行-->
      <div class="common-form">结算银行账户</div>
      <el-form-item label="账户类型" prop="acctTypeCode">
        <el-radio-group v-model="form.baseInfo.acctTypeCode"
                        :disabled="form.baseInfo.subject_type !== 'SUBJECT_TYPE_INDIVIDUAL'"
                        @input="acctTypeCodeChange">
          <el-radio label="58">经营者个人银行卡</el-radio>
          <el-radio label="57">对公银行账户</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="银行账号" prop="acctNo">
        <el-input v-model="form.baseInfo.acctNo" type="number" class="max-w460"
                  @change="searchBanksByBankAccount"></el-input>
      </el-form-item>
      <el-form-item label="开户名称" prop="acctName">
        <el-input type="text" v-model="form.baseInfo.acctName" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="开户银行" prop="openningBankName">
        <el-select size="small" v-model="form.baseInfo.openningBankName" placeholder="开户银行" class="max-w460 f-item">
          <el-option v-for="(item, index) in bankList" :key="index" :label="item.mergerName"
                     :value="item.mergerName"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="结算账户开户行号" prop="openningBankCode">
        <el-input type="text" v-model="form.baseInfo.openningBankCode" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="结算账户清算行号" prop="clearingBankCode">
        <el-input type="text" v-model="form.baseInfo.clearingBankCode" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="结算银行卡正面" prop="bank_card">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('bank_card')">选择图片</el-button>
          <div v-if="form.baseInfo.bank_card !== undefined" class="img">
            <img :src="bank_cardFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
    </el-form>

    <!--资质信息-->
    <el-form v-if="stepActive===1" ref="qualificationInfo" size="small" :model="form.qualificationInfo"
             :rules="stepForm_rules1"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--营业执照-->
      <div class="common-form">营业信息</div>
      <div v-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_ENTERPRISE'">
        <el-form-item label="营业执照照片" prop="license_copy">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('license_copy')">选择图片</el-button>
            <div v-if="form.qualificationInfo.license_copy !== undefined" class="img">
              <img :src="license_copyFilePath" width="200" height="200"/>
            </div>
          </el-row>
        </el-form-item>
        <el-form-item label="注册号/统一社会信用代码" prop="merBlis">
          <el-input type="text" v-model="form.qualificationInfo.merBlis" class="max-w460"
                    :disabled="payInfo.op==='replenish'"></el-input>
        </el-form-item>
        <el-form-item label="商户名称" prop="merchant_name">
          <el-input type="text" v-model="form.qualificationInfo.merchant_name" class="max-w460"
                    :disabled="payInfo.op==='replenish'"></el-input>
        </el-form-item>
        <el-form-item label="个体户经营者/法人姓名" prop="legal_person">
          <el-input v-model="form.qualificationInfo.legal_person" class="max-w460"
                    :disabled="payInfo.op==='replenish'"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="license_address">
          <el-input v-model="form.qualificationInfo.license_address" class="max-w460"
                    :disabled="payInfo.op==='replenish'"></el-input>
        </el-form-item>
        <el-form-item label="有效期类型" prop="period_type">
          <el-radio-group v-model="form.qualificationInfo.period_type" @input="period_typeChange"
                          :disabled="payInfo.op==='replenish'">
            <el-radio label="0">定期</el-radio>
            <el-radio label="1">长期有效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="有效期限开始日期" prop="merBlisStDt">
          <el-date-picker
            size="small"
            v-model="form.qualificationInfo.merBlisStDt"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options='pickerAddStart(form.qualificationInfo.merBlisExpDt)'
            @change="($event)=>limitPeriodDate('start',$event)"
            :disabled="payInfo.op==='replenish'"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="有效期限结束日期" prop="merBlisExpDt" v-if="form.qualificationInfo.period_type ==='0'">
          <el-date-picker
            size="small"
            v-model="form.qualificationInfo.merBlisExpDt"
            align="right"
            unlink-panels
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options='pickerAddEnd(form.qualificationInfo.merBlisStDt)'
            @change="($event)=>limitPeriodDate('end',$event)"
            :disabled="payInfo.op==='replenish'"
          ></el-date-picker>
        </el-form-item>
      </div>
      <div>
        <el-form-item label="商户门头照" prop="merchant_photo">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('merchant_photo')">选择图片</el-button>
            <div v-if="form.qualificationInfo.merchant_photo !== undefined" class="img">
              <img :src="merchant_photoFilePath" width="200" height="200"/>
            </div>
          </el-row>
        </el-form-item>
        <el-form-item label="商铺内部照片" prop="shopinner">
          <el-row>
            <el-button icon="el-icon-picture-outline" @click="openUpload('shopinner')">选择图片</el-button>
            <div v-if="form.qualificationInfo.shopinner !== undefined" class="img">
              <img :src="shopinnerFilePath" width="200" height="200"/>
            </div>
          </el-row>
        </el-form-item>
      </div>
      <!--超级管理员信息-->
      <div class="common-form">经营者/法人身份证件</div>
      <el-form-item label="商户经营内容" prop="merBusiContent">
        <el-select v-model="form.qualificationInfo.merBusiContent" placeholder="请选择商户经营内容"
                   :disabled="payInfo.op==='replenish'">
          <el-option label="餐饮、宾馆、娱乐、珠宝金饰、工艺美术品" value="640" disabled></el-option>
          <el-option label="房地产汽车类" value="641" disabled>
          </el-option>
          <el-option label="百货、中介、培训、景区门票等" value="642" disabled>
          </el-option>
          <el-option label="批发类商户" value="643" disabled>
          </el-option>
          <el-option label="加油、超市类" value="644" disabled>
          </el-option>
          <el-option label="交通运输售票" value="645" disabled>
          </el-option>
          <el-option label="水电气缴费" value="646" disabled>
          </el-option>
          <el-option label="政府类" value="647" disabled>
          </el-option>
          <el-option label="便民类" value="648" disabled>
          </el-option>
          <el-option label="公立医院、公立学校、慈善" value="649" disabled>
          </el-option>
          <el-option label="宾馆餐饮娱乐类" value="650" disabled>
          </el-option>
          <el-option label="房产汽车类" value="651" disabled>
          </el-option>
          <el-option label="批发类" value="652" disabled>
          </el-option>
          <el-option label="超市加油类" value="653" disabled>
          </el-option>
          <el-option label="一般类商户" value="654">
          </el-option>
          <el-option label="三农商户" value="655">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证件类型" prop="larIdType">
        <el-select v-model="form.qualificationInfo.larIdType" placeholder="请选择">
          <el-option label="中国大陆居民-身份证" value="01"></el-option>
          <el-option label="其他国家或地区居民-护照" value="02" disabled>
          </el-option>
          <el-option label="港澳通行证" value="03" disabled>
          </el-option>
          <el-option label="台胞证" value="04" disabled>
          </el-option>
          <el-option label="其它证件" value="99" disabled>
          </el-option>
        </el-select>
      </el-form-item>

      <!--营业执照-->
      <div class="common-form">身份证信息</div>
      <el-form-item label="身份证人像面照片" prop="id_card_copy">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('id_card_copy')">选择图片</el-button>
          <div v-if="form.qualificationInfo.id_card_copy !== undefined" class="img">
            <img :src="id_card_copyFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="身份证国徽面照片" prop="id_card_national">
        <el-row>
          <el-button icon="el-icon-picture-outline" @click="openUpload('id_card_national')">选择图片</el-button>
          <div v-if="form.qualificationInfo.id_card_national !== undefined" class="img">
            <img :src="id_card_nationalFilePath" width="200" height="200"/>
          </div>
        </el-row>
      </el-form-item>
      <el-form-item label="身份证姓名" prop="larName">
        <el-input type="text" v-model="form.qualificationInfo.larName" class="max-w460"
                  :disabled="payInfo.op==='replenish'"></el-input>
      </el-form-item>
      <el-form-item label="身份证号码" prop="larIdcard">
        <el-input type="text" v-model="form.qualificationInfo.larIdcard" class="max-w460"
                  :disabled="payInfo.op==='replenish'"></el-input>
      </el-form-item>
      <el-form-item label="身份证有效期类型" prop="card_period_type">
        <el-radio-group v-model="form.qualificationInfo.card_period_type" @input="card_period_typeChange"
                        :disabled="payInfo.op==='replenish'">
          <el-radio label="0">定期</el-radio>
          <el-radio label="1">长期有效</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="身份证有效期开始时间" prop="card_merBlisStDt">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.card_merBlisStDt"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddStart(form.qualificationInfo.card_merBlisExpDt)'
          @change="($event)=>limitDate('start',$event)"
          :disabled="payInfo.op==='replenish'"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="身份证有效期结束时间" prop="card_merBlisExpDt"
                    v-if="form.qualificationInfo.card_period_type ==='0'">
        <el-date-picker
          size="small"
          v-model="form.qualificationInfo.card_merBlisExpDt"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :picker-options='pickerAddEnd(form.qualificationInfo.card_merBlisStDt)'
          @change="($event)=>limitDate('end',$event)"
          :disabled="payInfo.op==='replenish'"
        ></el-date-picker>
      </el-form-item>

      <div v-if="form.baseInfo.subject_type === 'SUBJECT_TYPE_ENTERPRISE'">
        <div class="common-form">协议</div>
        <el-form-item label="协议" prop="merchant_xy">
          <el-row>
            <div style="display: inline-table; align-items: flex-start;">
              <el-button type="primary" @click="chooseAtt">上传附件</el-button>
              <div class="tips" style="color: red;">
                最多可上传 <span style="font-size: 20px">{{ fileMaxSize }}</span> 个附件,单个附件不能超过2M
              </div>
              <!-- 文件列表展示 -->
              <div class="file-list">
                <div v-for="(file, index) in fileList" :key="index" class="file-item">
                  <!-- 图片预览 -->
                  <div v-if="isImage(file)" class="preview-box">
                    <el-image
                      :src="file.filePath"
                      :preview-src-list="[file.filePath]"
                      fit="cover"
                      class="preview-image"
                    />
                  </div>

                  <!-- 视频预览 -->
                  <div v-else-if="isVideo(file)" class="preview-video-box">
                    <video
                      :src="file.filePath"
                      controls
                      class="preview-video"
                    />
                  </div>

                  <!-- 其他文件类型 -->
                  <div v-else class="file-info">
                    <i class="el-icon-document"/>
                    <span class="file-name">{{ file.realName }}</span>
                  </div>

                  <!-- 文件操作 -->
                  <div class="file-actions">
                    <el-button
                      type="text"
                      @click="downloadFile(file)"
                    >
                      下载
                    </el-button>
                    <el-button
                      type="text"
                      @click="handleRemove(file)"
                    >
                      删除
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-row>
        </el-form-item>
      </div>

      <!--超级管理员信息-->
      <div class="common-form">超级管理员信息</div>
      <el-form-item label="超级管理员姓名" prop="merContactName">
        <el-input type="text" v-model="form.qualificationInfo.merContactName" prefix-icon="el-icon-user" clearable
                  :placeholder="$t('login.user')" class="max-w460" :disabled="payInfo.op==='replenish'"></el-input>
      </el-form-item>
      <el-form-item label="超级管理员联系手机" prop="merContactMobile">
        <el-input v-model="form.qualificationInfo.merContactMobile" prefix-icon="el-icon-phone" clearable
                  class="max-w460"
                  :placeholder="$t('login.mobilePlaceholder')"
                  :disabled="payInfo.op==='replenish'">
        </el-input>
      </el-form-item>
    </el-form>

    <!--结算规则-->
    <div v-if="stepActive===2">
      <div class="common-form" style="display: flex">结算费率
        <promptMessages
          :messages="['1、您进店的产品选b2收银台，然后费率填300，301，302，303。',
      '2、微信和支付宝交易不封顶，银行卡中的借记卡才封顶。','3、银行卡的费率，借记卡0.5%，然后上限20，下限0，贷记卡0.6%，然后上限999999，下限0。']"></promptMessages>
      </div>
      <el-table :data="form.settlementInfo" border style="width: 100%;">
        <el-table-column prop="feeRateTypeCode" :label="tableHeadName.feeRateTypeCode" width="100px">
          <template slot-scope="scope">
            <el-input v-model="scope.row['feeRateTypeCode']" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="feeRateTypeName" :label="tableHeadName.feeRateTypeName" width="220px">
          <template slot-scope="scope">
            <el-input v-model="scope.row['feeRateTypeName']" disabled></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="feeRatePct" :label="tableHeadName.feeRatePct" width="100px">
          <template slot-scope="scope">
            <el-input v-model="scope.row['feeRatePct']" :disabled="payInfo.op==='view'"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="feeUpperAmtPcnt" :label="tableHeadName.feeUpperAmtPcnt" width="160px">
          <template slot-scope="scope">
            <el-input v-model="scope.row['feeUpperAmtPcnt']" :disabled="payInfo.op==='view'" type="number"
                      class="max-w460"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="feeLowerAmtPcnt" :label="tableHeadName.feeLowerAmtPcnt" width="160px">
          <template slot-scope="scope">
            <el-input v-model="scope.row['feeLowerAmtPcnt']" :disabled="payInfo.op==='view'" type="number"
                      class="max-w460"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="feeRateStDt" :label="tableHeadName.feeRateStDt" width="260px">
          <template slot-scope="scope">
            <el-date-picker
              size="small"
              v-model="scope.row['feeRateStDt']"
              :disabled="payInfo.op==='view'"
              align="right"
              unlink-panels
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <a href="javascript:void(0);" @click="deleteRateClick(scope.$index)"
               :disabled="payInfo.op==='view'">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <div>
        <el-button @click="addRateClick" type="text" size="small">+点击添加费率</el-button>
      </div>

      <div class="poster_footer" v-if="payInfo.op === 'edit' && form.checkInfo.applymentStatus === 40">
        <el-button icon="el-icon-s-check" type="danger" @click="rateChange">费率更改</el-button>
      </div>
    </div>

    <!--签约审核-->
    <el-form v-if="stepActive===3" ref="checkInfo" size="small" :model="form.checkInfo" :rules="stepForm_rules3"
             label-width="200px" :disabled="payInfo.op==='view'">
      <!--审核信息-->
      <div class="common-form">审核信息</div>
      <el-form-item label="审核状态" prop="applymentStatus">
        <el-select v-model="form.checkInfo.applymentStatus" placeholder="请选择审核状态" clearable size="small">
          <el-option v-for="dict in this.getDictDatas(DICT_TYPE.SUB_APPLY_CHECK_STATUS)"
                     :key="dict.value" :label="dict.label" :value="parseInt(dict.value)"/>
        </el-select>
      </el-form-item>
      <el-form-item label="审核时间" prop="checkTime">
        <el-input class="max-w460" v-model="form.checkInfo.checkTime" disabled></el-input>
      </el-form-item>
      <el-form-item label="审核备注" prop="checkNote">
        <el-input type="textrate" v-model="form.checkInfo.checkNote" class="max-w460"></el-input>
      </el-form-item>
    </el-form>

    <!--开通完成-->
    <div v-if="stepActive===4">
      <el-result icon="success" title="注册成功" sub-title="审核完成后，您可以使用登录账号以及手机号登录系统">
        <template #extra>
          <el-button type="primary" @click="goLogin">前去登录</el-button>
        </template>
      </el-result>
    </div>

    <div class="common-button-wrapper" v-if="payInfo.op==='replenish'">
      <el-button v-if="stepActive>0 && stepActive<2" @click="pre">上一步</el-button>
      <el-button v-if="stepActive<1" type="primary" @click="next">下一步</el-button>
      <el-button v-if="stepActive===1" type="danger" @click="replenish">附件补充上传</el-button>
    </div>

    <div class="common-button-wrapper" v-else>
      <el-button v-if="stepActive>0 && stepActive<4" @click="pre">上一步</el-button>
      <el-button v-if="stepActive<3" type="primary" @click="next">下一步</el-button>
      <el-button v-if="stepActive===3" type="primary" @click="check">审核</el-button>
    </div>

    <!--区域 -->
    <LakalaRate v-if="show_rate" :show_rate="show_rate" :rates="rateOptions"
                @closeRate="closeRateFunc"></LakalaRate>

    <!--上传图片组件-->
    <Upload v-if="isupload" :config="uploadConfig" :isupload="isupload" @returnImgs="returnImgsFunc">
      上传图片
    </Upload>

    <Upload v-if="isuploadAtt" :isupload="isuploadAtt" :config="{ total: fileMaxSize }"
            @returnImgs="returnAttFunc"></Upload>
  </div>
</template>

<script>
import LakalaRate from '../dialog/LakalaRate.vue';
import promptMessages from '@/components/messages';
import draggable from 'vuedraggable';
import SupplierApi from '@/api/supplier.js';
import DataApi from '@/api/data.js';
import Upload from '@/components/file/Upload';
import moment from 'moment'
import {isNil, some, remove} from 'lodash-es';

export default {
  name: "LakalaApply",
  props: {
    payInfo: {
      type: Object,
      default: {}
    },
  },
  components: {
    Upload,
    draggable,
    LakalaRate
  },
  data() {
    return {
      loading: false,
      stepActive: 0,
      uploadConfig: {
        uploadType: 'Local'
      },
      /*显示费率选中*/
      show_rate: false,
      /*费率数据源*/
      rateOptions: [
        {
          name: '银联借记卡',
          value: '300',
          remark: '银联借记卡',
          checked: true,
          disabled: false,
          rate: '0.5',
          upper: '20',
          lower: '0'
        },
        {
          name: '银联贷记卡',
          value: '301',
          remark: '',
          checked: true,
          disabled: false,
          rate: '0.6',
          upper: '999999',
          lower: '0'
        },
        {
          name: '微信',
          value: '302',
          rate: '0.6',
          remark: '',
          checked: true,
          disabled: false,
        },
        {
          name: '微信借记',
          value: '338',
          rate: '0.6',
          remark: '微信借贷记行业费率',
          disabled: false,
        },
        {
          name: '微信贷记',
          value: '339',
          rate: '0.6',
          remark: '微信借贷记行业费率',
          disabled: false,
        },
        {
          name: '支付宝',
          value: '303',
          remark: '',
          disabled: false,
          rate: '0.6',
        },
        {
          name: '翼支付',
          value: '306',
          remark: '',
          disabled: false,
        }, {
          name: '银联二维码借记卡',
          value: '314',
          remark: '',
          disabled: false,
        }, {
          name: '银联二维码贷记卡',
          value: '315',
          remark: '',
          disabled: false,
        }, {
          name: '无卡贷记',
          value: '321',
          remark: '只有 御风云码 产品支持此费率',
          disabled: false,
        }, {
          name: '支付账户',
          value: '319',
          remark: '',
          disabled: false,
        }, {
          name: 'B2B转账',
          value: '322',
          remark: '',
          disabled: false,
        }, {
          name: '微信线上（千米专用）',
          value: '400',
          remark: '',
          disabled: false,
        }, {
          name: '支付宝线上（千米专用）',
          value: '401',
          remark: '',
          disabled: false,
        }, {
          name: '微信刷脸',
          value: '307',
          remark: '',
          disabled: false,
        }, {
          name: '微信刷脸借记',
          value: '342',
          remark: '微信借贷记行业费率',
          disabled: false,
        }, {
          name: '微信刷脸贷记',
          value: '343',
          remark: '微信借贷记行业费率',
          disabled: false,
        }, {
          name: '云闪付借记-优惠',
          value: '411',
          remark: '',
          disabled: false,
        }, {
          name: '云闪付贷记-优惠',
          value: '412',
          remark: '',
          disabled: false,
        }, {
          name: '银联二维码借记-优惠',
          value: '413',
          remark: '',
          disabled: false,
        }, {
          name: '银联二维码贷记-优惠',
          value: '414',
          remark: '',
          disabled: false,
        }, {
          name: '支付宝费率-优惠',
          value: '415',
          remark: '',
          disabled: false,
        }, {
          name: '数字货币',
          value: '318',
          remark: '',
          disabled: false,
        },
      ],
      /*表格标题名称*/
      tableHeadName: {
        feeRateTypeCode: '费率类型',
        feeRateTypeName: '费率类型名称',
        feeRatePct: '手续费率(%)',
        feeUpperAmtPcnt: '单笔交易手续费封顶',
        feeLowerAmtPcnt: '单笔交易手续费保底',
        feeRateStDt: '手续费生效日期'
      },
      /*切换菜单*/
      license_copyFilePath: '',
      id_card_copyFilePath: '',
      id_card_nationalFilePath: '',
      merchant_photoFilePath: '',
      bank_cardFilePath: '',
      shopinnerFilePath: '',
      /*是否上传图片*/
      isupload: false,
      isuploadAtt: false,
      /*银行列表*/
      bankList: [],
      /*省市区*/
      areaList: [],
      rateList: [],
      fileType: 'logo',
      /*form表单数据*/
      form: {
        applymentId: '',
        applymentNo: '',
        applymentType: 40,
        applymentTypes: ['WECHAT'],
        baseInfo: {
          subject_type: 'SUBJECT_TYPE_INDIVIDUAL',
          merRegName: '商户_',
          merBizName: '',
          posType: 'WECHAT_PAY',
          acctTypeCode: '58',
          acctName: '',
          openningBankName: '',
          openningBankCode: '',
          clearingBankCode: '',
          acctNo: '',
          merRegDistCode: '',
          merRegAddr: '',
          mccCode: '5963',
          bank_card: undefined,
        },
        qualificationInfo: {
          merContactName: '',
          merContactMobile: '',
          license_copy: undefined,
          merBlis: '',
          merchant_name: '',
          legal_person: '',
          license_address: '',
          merBlisStDt: '',
          merBlisExpDt: '',
          merBusiContent: '654',
          larIdType: '01',
          id_card_copy: undefined,
          id_card_national: undefined,
          merchant_photo: undefined,
          shopinner: undefined,
          larName: '',
          larIdcard: '',
          card_period_type: '0',
          period_type: '0',
          card_merBlisStDt: '',
          card_merBlisExpDt: '',
          sales_scenes_type: [],
          mini_program_appid: '',
          mini_program_sub_appid: '',
          mini_program_pics: [],
          store_entrance_pic: [],
          indoor_pic: [],
          merchant_xy: [],
          domain: '',
          web_authorisation: '',
          mp_appid: '',
          biz_store_name: '',
          biz_address_code: '',
          biz_store_address: '',
          biz_sub_appid: '',
          mp_sub_appid: '',
          mp_pics: [],
          app_appid: '',
          app_sub_appid: '',
          app_pics: [],
        },
        settlementInfo: [],
        checkInfo: {
          applymentStatus: 10,
          checkTime: '',
          checkNote: '',
        },
        stepForm_4: {},
      },
      stepForm_rules01:{
        applymentTypes: [
          {required: true, message: '请选择进件支付类型'}
        ],
      },
      stepForm_rules0: {
        posType: [
          {required: true, message: '请选择进件POS类型'}
        ],
        subject_type: [
          {required: true, message: '请选择主体类型'}
        ],
        merRegName: [
          {required: true, message: '请输入商户简称'}
        ]
        , mccCode: [
          {required: true, message: '请输入商户MCC编号'}
        ],
        acctTypeCode: [
          {required: true, message: '请选择账户类型'}
        ],
        merRegAddr: [
          {required: true, message: '请输入商户详细地址'}
        ],
        merRegDistCode: [
          {required: true, message: '请选择商户地区'}
        ],
        acctName: [
          {required: true, message: '请输入开户名称'}
        ],
        openningBankName: [
          {required: true, message: '请选择开户银行'}
        ],
        openningBankCode: [
          {required: true, message: '请输入结算账户开户行号'}
        ],
        clearingBankCode: [
          {required: true, message: '请输入结算账户清算行号'}
        ],
        acctNo: [
          {required: true, message: '请输入银行账号'}
        ],
        bank_card: [
          {required: true, message: '结算银行卡正面'}
        ],
      },
      stepForm_rules1: {
        merBusiContent: [
          {required: true, message: '请选择商户经营内容'}
        ],
        merContactName: [
          {required: true, message: '请输入超级管理员姓名', trigger: ['blur', 'change']}
        ],
        merContactMobile: [
          {required: true, message: '请输入超级管理员联系手机', trigger: 'blur'},
          {pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change']}
        ],
        license_copy: [
          {required: true, message: '请上传营业执照照片'}
        ],
        merBlis: [
          {required: true, message: '请输入注册号/统一社会信用代码'}
        ],
        merchant_name: [
          {required: true, message: '请输入商户名称'}
        ],
        legal_person: [
          {required: true, message: '请输入个体户经营者/法人姓名'}
        ],
        license_address: [
          {required: true, message: '请输入注册地址'}
        ],
        merBlisStDt: [
          {required: true, message: '请选择有效期限开始日期', trigger: ['blur', 'change']}
        ],
        merBlisExpDt: [
          {required: true, message: '请选择有效期限结束日期', trigger: ['blur', 'change']}
        ],
        larIdType: [
          {required: true, message: '请选择证件类型'}
        ],
        merchant_photo: [
          {required: true, message: '请上传商户门头照'}
        ],
        shopinner: [
          {required: true, message: '请上传商铺内部照片'}
        ],
        id_card_copy: [
          {required: true, message: '请上传身份证人像面照片'}
        ],
        merchant_xy: [
          {required: true, message: '请上传协议附件'}
        ],
        id_card_national: [
          {required: true, message: '请上传身份证国徽面照片'}
        ],
        larName: [
          {required: true, message: '请输入身份证姓名'}
        ],
        larIdcard: [
          {required: true, message: '请输入身份证号码'}
        ],
        card_period_type: [
          {required: true, message: '请选择身份证有效期类型'}
        ],
        card_merBlisStDt: [
          {required: true, message: '请选择身份证有效期限开始日期', trigger: ['blur', 'change']}
        ],
        card_merBlisExpDt: [
          {required: true, message: '请选择身份证有效期限结束日期', trigger: ['blur', 'change']}
        ],
        mini_program_appid: [
          {required: true, message: '请输入服务商小程序APPID'}
        ],
        mini_program_sub_appid: [
          {required: true, message: '请输入商家小程序APPID'}
        ],
        mp_appid: [
          {required: true, message: '请输入服务商公众号APPID'}
        ],
        mp_sub_appid: [
          {required: true, message: '请输入商家公众号APPID'}
        ],
        app_appid: [
          {required: true, message: '请输入服务商应用APPID'}
        ],
        app_sub_appid: [
          {required: true, message: '请输入商家应用APPID'}
        ],
        // sales_scenes_type: [
        //   {type: 'array', required: true, message: '请选择经营场景类型'}
        // ],
        mini_program_pics: [
          {required: true, message: '请上传小程序截图'}
        ],
        domain: [
          {required: true, message: '请输入互联网网站域名'}
        ],
        web_authorisation: [
          {required: true, message: '请上传网站授权函'}
        ],

      },
      stepForm_rules2: {},
      stepForm_rules3: {},
      stepForm_rules4: {},
      pickerAddStart(val) {
        return {
          disabledDate(time) {
            if (val) {
              const start = moment(new Date(val), 'YYYY-MM-DD')
              return moment(time.getTime()).isAfter(start);
            }
          },
        }
      },
      pickerAddEnd(val) {
        return {
          disabledDate(time) {
            if (val) {
              const start = moment(new Date(val), 'YYYY-MM-DD')
              return moment(time.getTime()).isBefore(start);
            }
          },
        }
      },
      fileList: [],
      fileMaxSize: 5
    }
  },
  inject: [],
  mounted() {
    this.getAreaData();
    this.getBankList();
  },
  methods: {
    // 添加这个方法是因为，点击"确定"按钮会获取到当前时间，不受picker-options的限制并赋值到输入框中
    limitDate(type, date) {
      var dateTime = new Date(date).getTime();
      //开始时间的时间戳不能大于结束时间
      if (type === "start" && dateTime && this.form.qualificationInfo.card_merBlisExpDt && dateTime > new Date(this.form.qualificationInfo.card_merBlisExpDt).getTime()) {
        this.$message.error("开始时间不能大于结束时间！");
        this.form.qualificationInfo.card_merBlisStDt = "";
      }
      if (type === "end" && dateTime && this.form.qualificationInfo.card_merBlisStDt && dateTime < new Date(this.form.qualificationInfo.card_merBlisStDt).getTime()) {
        this.$message.error("结束时间不能小于开始时间！");
        this.form.qualificationInfo.card_merBlisExpDt = "";
      }
    },
    limitPeriodDate(type, date) {
      var dateTime = new Date(date).getTime();
      //开始时间的时间戳不能大于结束时间
      if (type === "start" && dateTime && this.form.qualificationInfo.merBlisExpDt && dateTime > new Date(this.form.qualificationInfo.merBlisExpDt).getTime()) {
        this.$message.error("开始时间不能大于结束时间！");
        this.form.qualificationInfo.merBlisStDt = "";
      }
      if (type === "end" && dateTime && this.form.qualificationInfo.merBlisStDt && dateTime < new Date(this.form.qualificationInfo.merBlisStDt).getTime()) {
        this.$message.error("结束时间不能小于开始时间！");
        this.form.qualificationInfo.merBlisExpDt = "";
      }
    },
    sales_scenes_typeChange() {

    },
    repickPayType() {

    },
    pre() {
      this.stepActive -= 1
    },
    getFormName() {
      let text = '';
      switch (this.stepActive) {
        case 0:
          text = 'baseInfo'
          break;
        case 1:
          text = 'qualificationInfo'
          break;
        case 2:
          text = 'settlementInfo'
          break;
        case 3:
          text = 'checkInfo'
          break;

      }
      return text;
    },
    next() {
      let self = this;
      const formName = self.getFormName()

      if (formName === 'settlementInfo') {
        self.stepActive += 1
      } else {
        self.$refs[formName].validate((valid) => {
          if (valid) {
            if (self.stepActive < 4) {
              self.stepActive += 1
            }
          } else {
            return false
          }
        })
      }
    },
    save() {
      let self = this;
      const formName = self.getFormName()
      self.$refs[formName].validate((valid) => {
        if (valid) {
          let Params = {
            ...self.form
          };
          SupplierApi.addApplyment(Params)
            .then(res => {
              self.stepActive += 1
            })
            .catch(error => {
            });
        } else {
          return false
        }
      })
    },
    check() {
      let self = this;
      const formName = self.getFormName()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let Params = {
            ...self.form
          };
          SupplierApi.checkLakalaApplyment(Params)
            .then(res => {
              if (self.form.checkInfo.applymentStatus === 40) {
                self.stepActive += 1
              } else {
                self.$message({
                  message: '处理完毕',
                  type: 'success'
                });
                self.$router.push('/supplier/applyment/index');
              }
            })
            .catch(error => {
            });
        } else {
          return false
        }
      })
    },
    replenish() {
      let self = this;
      const formName = self.getFormName()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let Params = {
            ...self.form,
          };
          SupplierApi.replenishFileLakala(Params)
            .then(res => {
              self.$message({
                message: '处理完毕',
                type: 'success'
              });
              self.$router.push('/supplier/applyment/index');
            })
            .catch(error => {
            });
        } else {
          return false
        }
      })
    },
    /*上传*/
    openUpload(e) {
      this.fileType = e;
      this.isupload = true;
      if (this.fileType === 'license_copy' || this.fileType === 'id_card_national' || this.fileType === 'id_card_copy' || this.fileType === 'merchant_photo' || this.fileType === 'bank_card' || this.fileType === 'shopinner') {
        this.uploadConfig = {
          total: 1,
          maxSelect: 1,
          uploadType: 'Local',
          fileType: 'image'
        };
      } else if (this.fileType === 'mp_pics' || this.fileType === 'app_pics' || this.fileType === 'mini_program_pics' || this.fileType === 'store_entrance_pic' || this.fileType === 'indoor_pic' || this.fileType === 'qualifications' || this.fileType === 'activities_additions') {
        this.uploadConfig = {
          total: 5,
          maxSelect: 5,
          uploadType: 'Local',
          fileType: 'image'
        };
      }
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.fileType == 'license_copy') {
          this.license_copyFilePath = e[0].filePath;
          this.form.qualificationInfo.license_copy = e[0];
        } else if (this.fileType == 'id_card_national') {
          this.id_card_nationalFilePath = e[0].filePath;
          this.form.qualificationInfo.id_card_national = e[0];
        } else if (this.fileType == 'id_card_copy') {
          this.id_card_copyFilePath = e[0].filePath;
          this.form.qualificationInfo.id_card_copy = e[0];
        }else if (this.fileType == 'bank_card') {
          this.bank_cardFilePath = e[0].filePath;
          this.form.baseInfo.bank_card = e[0];
        }  else if (this.fileType == 'merchant_photo') {
          this.merchant_photoFilePath = e[0].filePath;
          this.form.qualificationInfo.merchant_photo = e[0];
        } else if (this.fileType == 'shopinner') {
          this.shopinnerFilePath = e[0].filePath;
          this.form.qualificationInfo.shopinner = e[0];
        } else if (this.fileType == 'mp_pics') {
          let imgs = this.form.qualificationInfo.mp_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'mp_pics', imgs);
        } else if (this.fileType == 'mini_program_pics') {
          let imgs = this.form.qualificationInfo.mini_program_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'mini_program_pics', imgs);
        } else if (this.fileType == 'store_entrance_pic') {
          let imgs = this.form.qualificationInfo.store_entrance_pic.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'store_entrance_pic', imgs);
        } else if (this.fileType == 'indoor_pic') {
          let imgs = this.form.qualificationInfo.indoor_pic.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'indoor_pic', imgs);
        } else if (this.fileType == 'app_pics') {
          let imgs = this.form.qualificationInfo.app_pics.concat(e);
          // 兼容后端
          for (let i = 0; i < imgs.length; i++) {
            if (typeof (imgs[i].imageId) == "undefined") {
              this.$set(imgs[i], 'imageId', imgs[i].fileId);
            }
          }
          this.$set(this.form.qualificationInfo, 'app_pics', imgs);
        }

      }
      this.isupload = false;
    },
    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    },
    /*删除设备图片*/
    deleteImg(arry, index) {
      arry.splice(index, 1);
    },
    //提交表单
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          SupplierApi.addApplyment(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，编辑成功',
                type: 'success'
              });
              self.$router.push('/setting/applyment/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    subjectTypeChange(e) {
      let self = this;
      if (e !== 'SUBJECT_TYPE_INDIVIDUAL') {
        self.form.baseInfo.acctTypeCode = '57';
      } else if (e === 'SUBJECT_TYPE_INDIVIDUAL') {
        self.form.baseInfo.acctTypeCode = '58';
      }
      // self.form.baseInfo.acctName = '';
      // self.form.baseInfo.openningBankName = '';
      // self.form.baseInfo.acctNo = '';
      self.getBankList();
    },
    acctTypeCodeChange(e) {
      let self = this;
      self.form.baseInfo.acctName = '';
      self.form.baseInfo.openningBankName = '';
      self.form.baseInfo.acctNo = '';
      self.getBankList();
    },
    period_typeChange(e) {
      let self = this;
      if (self.form.qualificationInfo.period_type == '0') {
        if (isNil(self.form.qualificationInfo.merBlisStDt)) {
          self.form.qualificationInfo.merBlisStDt = ''
        } else {
          //默认增加10年
          self.form.qualificationInfo.merBlisStDt = moment(new Date(self.form.qualificationInfo.merBlisStDt), 'YYYY-MM-DD').add(10, 'years').format('YYYY-MM-dd')
        }
      } else {
        self.form.qualificationInfo.merBlisExpDt = '长期';
      }
    },
    card_period_typeChange(e) {
      let self = this;
      if (self.form.qualificationInfo.card_period_type == '0') {
        if (isNil(self.form.qualificationInfo.card_merBlisStDt)) {
          self.form.qualificationInfo.card_merBlisExpDt = ''
        } else {
          //默认增加10年
          self.form.qualificationInfo.card_merBlisExpDt = moment(new Date(self.form.qualificationInfo.card_merBlisStDt), 'YYYY-MM-dd').add(10, 'years').format('YYYY-MM-dd')
        }
      } else {
        self.form.qualificationInfo.card_merBlisExpDt = '长期';
      }
    },
    getAreaData() {
      let self = this;
      DataApi.getLakalaRegion({}, true)
        .then(res => {
          self.areaList = res.data;
        })
        .catch(error => {
        });
    },
    getBankList() {
      let self = this;
      if (self.form.baseInfo.acctTypeCode === '58') {

      } else {

      }
      DataApi.getBanking({level: 1}, true)
        .then(res => {
          self.bankList = res.data;
        })
        .catch(error => {
        });
    },
    handleBankAddressChange(item) {

    },
    searchBanksByBankAccount(queryString) {
      let self = this;
      if (self.form.baseInfo.acctTypeCode === '58') {
        DataApi.cardBin({accountNumber: queryString}, true)
          .then(res => {
            //仅获取第一个
            let data = res.data;
            self.form.baseInfo.openningBankName = data.bankName;
            self.form.baseInfo.openningBankCode = data.bankCode;
            self.form.baseInfo.clearingBankCode = data.clearingBankCode;
          })
          .catch(error => {
            self.form.baseInfo.openningBankName = '';
          });
      }
    },
    getData(applymentId) {
      let self = this;
      // 取到路由带过来的参数
      SupplierApi.applymentDetail({
        applymentId: applymentId
      }, true)
        .then(res => {
          let detail = res.data;
          // 将数据放在当前组件的数据内
          self.form.baseInfo = JSON.parse(detail.baseInfo);
          self.form.qualificationInfo = JSON.parse(detail.qualificationInfo);

          self.license_copyFilePath = (self.form.qualificationInfo.license_copy || {}).filePath;
          self.id_card_nationalFilePath = (self.form.qualificationInfo.id_card_national || {}).filePath;
          self.id_card_copyFilePath = (self.form.qualificationInfo.id_card_copy || {}).filePath;
          self.merchant_photoFilePath = (self.form.qualificationInfo.merchant_photo || {}).filePath;
          self.shopinnerFilePath = (self.form.qualificationInfo.shopinner || {}).filePath;
          self.bank_cardFilePath = (self.form.baseInfo.bank_card || {}).filePath;

          self.form.payInfo = JSON.parse(detail.payInfo);
          self.form.checkInfo = JSON.parse(detail.checkInfo);
          self.form.settlementInfo = JSON.parse(detail.settlementInfo);
          if (isNil(self.form.settlementInfo)) {
            self.form.settlementInfo = [];
          }
          if (isNil(self.form.checkInfo)) {
            self.form.checkInfo = {};
          }
          if (isNil(self.form.payInfo)) {
            self.form.payInfo = {};
          }
          self.form.applymentId = applymentId;
          self.form.checkInfo.applymentId = applymentId;
          self.form.applymentNo = detail.applymentNo;
        })
        .catch(error => {

        });

    },
    //提交表单
    onEditSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          SupplierApi.editApplyment(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: '恭喜你，编辑成功',
                type: 'success'
              });
              self.$router.push('/setting/applyment/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    rateChange() {
      let self = this;
      let form = self.form;
      self.loading = true;
      SupplierApi.changeRate({applymentId: self.form.applymentId, settlementInfo: self.form.settlementInfo}, true)
        .then(data => {
          self.loading = false;
          self.$message({
            message: '恭喜你，修改费率成功',
            type: 'success'
          });
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*添加费率*/
    addRateClick(e) {
      this.show_rate = true;
    },
    /*删除*/
    deleteRateClick(e) {
      let self = this;
      self.rateOptions.forEach(function (item) {
        if (self.form.settlementInfo[e].feeRateTypeCode === item['value']) {
          item.checked = false;
          item.index = null;
        }
      });

      self.form.settlementInfo.splice(e, 1);
    },
    /*关闭区域选中弹窗*/
    closeRateFunc(e) {
      let self = this;
      self.show_rate = e.statu;
      if (e.type != 'confirm') {
        return;
      }
      self.rateOptions = e.this_rate;

      e.this_rate.forEach(function (item, index) {
        const value = item['value'] + '';
        if ((item.checked === true || item.indeterminate === true) && !some(self.form.settlementInfo, {'feeRateTypeCode': value})) {
          self.form.settlementInfo.push({
            feeRateTypeCode: value,
            feeRateTypeName: item['name'],
            feeRatePct: item['rate'],
            feeUpperAmtPcnt: item['upper'],
            feeLowerAmtPcnt: item['lower'],
            feeRateStDt: '',
          });
        } else {
          if (item.checked === false && some(self.form.settlementInfo, {'feeRateTypeCode': value})) {
            remove(self.form.settlementInfo, (item) => item.feeRateTypeCode === value);
          }
        }
      });
      //更新表格变通做法
      self.form.settlementInfo.push([]);
      self.form.settlementInfo.pop();
    },
    /*选择图片*/
    chooseAtt(e) {
      this.img_type = e;
      this.isuploadAtt = true;
    },

    /*关闭选择图片*/
    returnAttFunc(e) {
      this.isuploadAtt = false;
      this.fileList = e;
    },
    isImage(file) {
      const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp']
      return imageTypes.includes(file.extension)
    },

    // 判断是否为视频
    isVideo(file) {
      const videoTypes = ['mp4', 'webm', 'ogg']
      return videoTypes.includes(file.extension)
    },
    // 移除文件
    handleRemove(file) {
      const index = this.fileList.indexOf(file)
      if (index !== -1) {
        this.fileList.splice(index, 1)
        this.$emit('file-remove', file)
      }
    },

    // 下载文件
    downloadFile(file) {
      let x = new XMLHttpRequest();
      x.open("GET", file.filePath, true);
      x.responseType = 'blob';
      x.onload = (e) => {
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a');
        a.href = url
        a.download = file.fileName
        a.click()
      }
      x.send();

    }
  },
  watch: {
    'payInfo': {
      handler(values, oldVal) {
        let oldTimeStamp = (typeof oldVal === 'undefined' ? 0 : oldVal.timeStamp);
        if (values.timeStamp && values.timeStamp != oldTimeStamp && values.applymentId) {
          this.getData(values.applymentId)
        }
      },
      immediate: true,
      deep: true
    },
    'fileList': {
      handler(newVal) {
        // 监听fileList变化，同步到merchant_xy
        // this.form.qualificationInfo.merchant_xy = newVal;
        this.$set(this.form.qualificationInfo, 'merchant_xy', newVal);
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>

.bank-autocomplete {
  li {
    line-height: normal;
    padding: 7px;

    .name {
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .code {
      font-size: 12px;
      color: #b4b4b4;
    }

    .highlighted .code {
      color: #ddd;
    }
  }
}

.tips {
  color: #ccc;
}

.subject-wrap {
  background: #f6f8fb !important;
}

.product-add {
  padding-bottom: 20px;
}

.f-item {
  width: 100%;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

.poster_footer {
  display: flex;
  justify-content: center;
  margin: 24px;
}

.file-list {
  margin-top: 20px;
  flex: 1;
}

.file-item {
  display: flex;
  align-items: center;
  padding: 10px 10px 10px 0;
  border-bottom: 1px solid #eee;
}

.preview-box {
  width: 100px;
  height: 100px;
  margin-right: 15px;
  overflow: hidden;
}


.preview-video-box {
  width: 400px;
  height: 100px;
  margin-right: 15px;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.preview-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.file-info {
  flex: 1;
  display: flex;
  align-items: center;
}

.file-name {
  margin-left: 10px;
  color: #606266;
}

.file-actions {
  margin-left: auto; /* 修改这里，使用auto让元素靠右 */
  display: flex; /* 添加flex布局使按钮水平排列 */
  align-items: center;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 7px;
}


</style>




// WEBPACK FOOTER //
// src/views/supplier/supplier/applyment/part/Lakala.vue